export const useFutureAddedPopUp = () => {
  const getPPSReasonData = (
    addedFutureNDCData: { heading: string; value: string; startDate: string; endDate: string }[]
  ) => {
    let data: { heading: string; value: string; startDate: string; endDate: string } | null = null;
    for (let i = 0; i < addedFutureNDCData.length; i++) {
      if (addedFutureNDCData[i].heading.toLocaleLowerCase() === 'pps reason') {
        data = addedFutureNDCData[i];
        break;
      }
    }
    return data;
  };

  return {
    getPPSReasonData,
  };
};
